<h3>Idée finale</h3>
<p>{{ finalIdea() ? finalIdea() : 'Aucune idée formulée pour le moment.' }}</p>